import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"
import '@/style.css'
import App from '@/App.vue'
import {createApp} from 'vue'
import {createPinia} from 'pinia'
import {VueFire, VueFireAuthWithDependencies,} from 'vuefire'
import {initializeApp as initializeFirebase} from 'firebase/app'
import {
  browserLocalPersistence,
  debugErrorMap,
  indexedDBLocalPersistence,
  prodErrorMap
} from "firebase/auth"
import {createRoutes, createUiRouter} from "@/router"
import Vuelidate from '@vuelidate/core'
import * as constants from "@/constants"
import { logger } from "@/logger";
import { createLoggerConfig } from "@/logger/config/loggerConfigFactory";

const environment = import.meta.env.MODE;

// Initialize logger and RUM
const config = createLoggerConfig(environment);
logger.initialize(config);

// Initialize app
const app = createApp(App);
const pinia = createPinia();
const firebase = initializeFirebase({
  appId: `eclips-content-ui-${import.meta.env.MODE}`,
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN
});
const vueFireModules = [
  VueFireAuthWithDependencies({
    dependencies: {
      errorMap: import.meta.env.PROD ? prodErrorMap : debugErrorMap,
      persistence: [
        indexedDBLocalPersistence,
        browserLocalPersistence
      ]
    }
  })
];

// Use
app.use(pinia);
app.use(VueFire, {
  firebaseApp: firebase,
  modules: vueFireModules
});
const routes = createRoutes(constants);
const router = createUiRouter(routes);
app.use(router);
app.use(Vuelidate);

// Mount
app.mount('#app');
